import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { LiveSession } from 'app/_models/live-session.model';

@Component({
  selector: 'live-sessions-modal',
  templateUrl: './live-sessions-modal.component.html'
})
export class LiveSessionsModalComponent implements OnInit {
  @Input() sessionData: LiveSession[];
  public routeRole: string;

  public cols: any[];
  public rows: any[];

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.rows = this.sessionData.map(data => {
      return {
        ...data,
        hideLink: !data.isWorkOrderSession(),
      };
    }).sort((a, b) => {
      return b.startTime.getTime() - a.startTime.getTime();
    });

    this.cols = [
      { field: 'name', header: 'Worker' },
      { field: 'site', header: 'Site' },
      { field: 'description', header: 'Work Order / Site Session' },
      { field: 'startTime', header: 'Start Time', type: 'date' },
      { type: 'link', linkText: 'view' },
    ];
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public goToWorkOrder(row) {
    this.activeModal.dismiss();
    this.router.navigate(['/' + this.routeRole + '/sites/' + row.siteId + '/work-orders/' + row.workOrderId]);
  }
}
